import { BillingPeriodEnum, CurrencyEnum, ExpenseStatusEnum, SubscriptionTypeEnum, TaxEnum, ExpenseItem, ExpenseKindEnum } from "@finway-group/shared/lib/models"

export const deliveryNoteURL = ""
export const oneWeek = 6.04e8

// ONE TIME PURCHASES

export const expenseDataDesk: any = {
    id: "209382697352811920938269",
    kind: ExpenseKindEnum.ONE_TIME_EXPENSE,
    expenseNumber: 1,
    datePurchased: new Date(2019, 0, 17),
    items: [
        {
            name: "Desk",
            quantity: 4,
            totalNetPrice: 420.0,
            _id: "209382697352811920938279",
            tax: TaxEnum.FIVE_PERCENT,
        } as ExpenseItem,
    ],
    currency: CurrencyEnum.USD,
    description: "Desks for the office",
    status: ExpenseStatusEnum.APPROVED,
    invoices: [],
    deliveryNote: "",
    invoiceNumber: "1",
    invoiceDate: new Date(2019, 0, 17),
    invoiceDueDate: new Date(2019, 0, 17),
    // references to other objects will be added once created
}

export const expenseDataLamp: any = {
    id: "309382697352811920938269",
    kind: ExpenseKindEnum.ONE_TIME_EXPENSE,
    expenseNumber: 2,
    datePurchased: new Date(2019, 4, 22),
    items: [
        {
            name: "Lamp",
            quantity: 11,
            totalNetPrice: 122.9,
            tax: TaxEnum.NINETEEN_PERCENT,
            _id: "409382697352811920938269",
        } as ExpenseItem,
        {
            name: "Stand",
            quantity: 11,
            totalNetPrice: 78.99,
            tax: TaxEnum.NINETEEN_PERCENT,
            _id: "209382697352811920938269",
        } as ExpenseItem,
    ],
    currency: CurrencyEnum.USD,
    description: "Lamps and for the desks in the office",
    status: ExpenseStatusEnum.REVIEWED,
    invoices: [],
    deliveryNote: "",
    invoiceNumber: "1",
    invoiceDate: new Date(2019, 0, 17),
    invoiceDueDate: new Date(2019, 0, 17),
    // references to other objects will be added once created
}

export const expenseDataMacbook: any = {
    id: "509382697352811920938269",
    kind: ExpenseKindEnum.ONE_TIME_EXPENSE,
    expenseNumber: 3,
    datePurchased: new Date(2019, 7, 5),
    items: [
        {
            name: "Macbook",
            quantity: 1,
            totalNetPrice: 1689,
            _id: "609382697352811920938269",
            tax: TaxEnum.FIVE_PERCENT,
        } as ExpenseItem,
    ],
    currency: CurrencyEnum.USD,
    description: "Notebook for the intern",
    status: ExpenseStatusEnum.DECLINED,
    invoices: [],
    // references to other objects will be added once created
}

export const expenseDataServer: any = {
    id: "709382697352811920938269",
    kind: ExpenseKindEnum.ONE_TIME_EXPENSE,
    expenseNumber: 13,
    datePurchased: new Date(2019, 5, 12),
    items: [
        {
            name: "Server",
            quantity: 1,
            totalNetPrice: 3899.88,
            _id: "809382697352811920938269",
            tax: TaxEnum.FIVE_PERCENT,
        } as ExpenseItem,
        {
            name: "Server Rack",
            quantity: 1,
            totalNetPrice: 320.0,
            _id: "909382697352811920938269",
            tax: TaxEnum.FIVE_PERCENT,
        } as ExpenseItem,
    ],
    currency: CurrencyEnum.EUR,
    description: "Local server for running Confluence/JIRA",
    status: ExpenseStatusEnum.DOCS_NEEDED,
    invoices: [],
    // references to other objects will be added once created
}

export const expenseDataMonitor: any = {
    id: "219382697352811920938269",
    kind: ExpenseKindEnum.ONE_TIME_EXPENSE,
    expenseNumber: 4,
    datePurchased: Date.now(),
    items: [
        {
            name: "Desktop Monitor",
            quantity: 1,
            totalNetPrice: 390,
            _id: "229382697352811920938269",
            tax: TaxEnum.FIVE_PERCENT,
        } as ExpenseItem,
    ],
    currency: CurrencyEnum.USD,
    description: "Monitor for Desktop, old one broke",
    status: ExpenseStatusEnum.PURCHASE_PENDING,
    invoices: [],
    // references to other objects will be added once created
}

export const expenseDataCamera: any = {
    id: "239382697352811920938269",
    kind: ExpenseKindEnum.ONE_TIME_EXPENSE,
    expenseNumber: 5,
    datePurchased: new Date(2019, 3, 29),
    items: [
        {
            name: "Security Camera",
            quantity: 5,
            totalNetPrice: 5 * 199,
            tax: TaxEnum.NINETEEN_PERCENT,
            _id: "249382697352811920938269",
        } as ExpenseItem,
    ],
    currency: CurrencyEnum.USD,
    description: "Needed to monitor office entrances",
    status: ExpenseStatusEnum.PAID,
    invoices: [],
    deliveryNote: deliveryNoteURL,
    invoiceNumber: "1",
    invoiceDate: new Date(2019, 0, 17),
    invoiceDueDate: new Date(2019, 0, 17),
    datePaidAt: new Date(2019, 0, 17),
    // references to other objects will be added once created
}

export const expenseDataCoffee: any = {
    id: "259382697352811920938269",
    kind: ExpenseKindEnum.ONE_TIME_EXPENSE,
    expenseNumber: 6,
    datePurchased: Date.now(),
    items: [
        {
            name: "Starbucks Coffee Beans",
            quantity: 10,
            totalNetPrice: 99.9,
            tax: 10,
            _id: "269382697352811920938269",
        } as ExpenseItem,
    ],
    currency: CurrencyEnum.USD,
    description: "Daily fuel for the devs",
    status: ExpenseStatusEnum.DONE,
    invoices: [],
    deliveryNote: deliveryNoteURL,
    invoiceNumber: "1",
    invoiceDate: new Date(2019, 0, 17),
    invoiceDueDate: new Date(2019, 0, 17),
    datePaidAt: new Date(2019, 0, 17),
    // references to other objects will be added once created
}

// SUBSCRIPTIONS

export const expenseAWSSubscription: any = {
    id: "279382697352811920938269",
    subscriptionType: SubscriptionTypeEnum.INITIAL_REQUEST,
    kind: ExpenseKindEnum.SUBSCRIPTION,
    expenseNumber: 7,
    renewalsExpenses: [],
    datePurchased: new Date(2019, 0, 17),
    name: "Amazon AWS",
    description: "Cloud technology to host our applications",
    totalNetPrice: 9.99,
    currency: CurrencyEnum.USD,
    billingPeriod: BillingPeriodEnum.MONTHLY,
    tax: TaxEnum.NINETEEN_PERCENT,
    dateCancellationDue: new Date(Date.now() + 4 * oneWeek),
    status: ExpenseStatusEnum.DONE,
    invoices: [],
    invoiceNumber: "1",
    invoiceDate: new Date(2019, 0, 17),
    invoiceDueDate: new Date(2019, 0, 17),
    datePaidAt: new Date(2019, 0, 17),
    isPaused: true, // should not create any recurring subs
    pauseIntervals: [{ datePauseStarted: new Date(2020, 7, 1) }],
    // references to other objects will be added once created
}

export const expensePrimeSubscription: any = {
    id: "289382697352811920938269",
    subscriptionType: SubscriptionTypeEnum.INITIAL_REQUEST,
    expenseNumber: 8,
    kind: ExpenseKindEnum.SUBSCRIPTION,
    renewalsExpenses: [],
    datePurchased: new Date(2019, 6, 30),
    name: "Amazon Prime",
    description: "Prime membership for fast and free deliveries",
    totalNetPrice: 9.99,
    currency: CurrencyEnum.USD,
    billingPeriod: BillingPeriodEnum.MONTHLY,
    tax: TaxEnum.NINETEEN_PERCENT,
    dateCancellationDue: new Date(Date.now() + oneWeek),
    status: ExpenseStatusEnum.DONE,
    invoices: [],
    invoiceNumber: "1",
    invoiceDate: new Date(2019, 0, 17),
    invoiceDueDate: new Date(2019, 0, 17),
    datePaidAt: new Date(2019, 0, 17),
    pauseIntervals: [
        { datePauseStarted: new Date(2020, 2, 1), datePauseEnded: new Date(2020, 4, 1) },
        { datePauseStarted: new Date(2020, 6, 1), datePauseEnded: new Date(2020, 7, 1) },
    ],
    // references to other objects will be added once created
}

export const expenseSlackSubscription: any = {
    id: "299382697352811920938269",
    subscriptionType: SubscriptionTypeEnum.INITIAL_REQUEST,
    expenseNumber: 9,
    kind: ExpenseKindEnum.SUBSCRIPTION,
    renewalsExpenses: [],
    datePurchased: new Date(2020, 10, 14),
    name: "Slack",
    description: "Paid version of the team messenger",
    totalNetPrice: 9.99,
    currency: CurrencyEnum.EUR,
    billingPeriod: BillingPeriodEnum.MONTHLY,
    dateCancellationDue: new Date(Date.now() + 52 * oneWeek),
    status: ExpenseStatusEnum.INVOICE_PENDING,
    invoices: [],
    // references to other objects will be added once created
}

export const expenseGithubSubscription: any = {
    id: "201382697352811920938269",
    subscriptionType: SubscriptionTypeEnum.INITIAL_REQUEST,
    expenseNumber: 10,
    kind: ExpenseKindEnum.SUBSCRIPTION,
    renewalsExpenses: [],
    datePurchased: new Date(2018, 8, 9),
    name: "Github",
    description: "Plattform to host repositories",
    totalNetPrice: 155.88,
    currency: CurrencyEnum.USD,
    billingPeriod: BillingPeriodEnum.YEARLY,
    tax: TaxEnum.NINETEEN_PERCENT,
    dateCancellationDue: new Date(Date.now() + 2 * oneWeek),
    status: ExpenseStatusEnum.DONE,
    invoices: [],
    invoiceNumber: "1",
    invoiceDate: new Date(2019, 0, 17),
    invoiceDueDate: new Date(2019, 0, 17),
    datePaidAt: new Date(2019, 0, 17),
    // references to other objects will be added once created
}

export const expenseGCPSubscription: any = {
    id: "202382697352811920938269",
    subscriptionType: SubscriptionTypeEnum.INITIAL_REQUEST,
    expenseNumber: 11,
    kind: ExpenseKindEnum.SUBSCRIPTION,
    renewalsExpenses: [],
    datePurchased: new Date(2019, 8, 9),
    name: "GCP Membership",
    description: "Google Cloud Platform for cloud technologies",
    totalNetPrice: 155.88,
    currency: CurrencyEnum.USD,
    billingPeriod: BillingPeriodEnum.YEARLY,
    tax: TaxEnum.NINETEEN_PERCENT,
    dateCancellationDue: new Date(Date.now() + 2 * oneWeek),
    status: ExpenseStatusEnum.DONE,
    invoices: [],
    invoiceNumber: "1",
    invoiceDate: new Date(2019, 0, 17),
    invoiceDueDate: new Date(2019, 0, 17),
    datePaidAt: new Date(2019, 0, 17),
    // references to other objects will be added once created
}

export const expenseMSOfficeSubscription: any = {
    id: "203382697352811920938269",
    subscriptionType: SubscriptionTypeEnum.INITIAL_REQUEST,
    expenseNumber: 12,
    kind: ExpenseKindEnum.SUBSCRIPTION,
    renewalsExpenses: [],
    datePurchased: new Date(2019, 8, 9),
    name: "MS Office",
    description: "Office Suit (Excel, Word, PowerPoint)",
    totalNetPrice: 155.88 / 4,
    currency: CurrencyEnum.USD,
    billingPeriod: BillingPeriodEnum.QUARTERLY,
    dateCancellationDue: new Date(Date.now() + 2 * oneWeek),
    status: ExpenseStatusEnum.APPROVED,
    invoices: [],
    invoiceNumber: "1",
    invoiceDate: new Date(2019, 0, 17),
    invoiceDueDate: new Date(2019, 0, 17),
    // references to other objects will be added once created
}
